import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ces-campaign-management',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.component.ts